<template>
  <tr @dblclick="$refs['actions'].callFirstStarredAction();"
    class="d-block d-lg-table-row bg-white px-2 py-2 mb-2 border p-lg-0 mb-lg-0 border-lg-0">
    <td class="d-block d-lg-table-cell">
      <span class="small d-lg-none fw-bold" data-no-export>{{ i18n('Id') }}</span>
      <FieldReadonly :value="provider.id" />
    </td>
    <td class="d-block d-lg-table-cell">
      <span class="small d-lg-none fw-bold" data-no-export>{{ i18n('Identifier') }}</span>
      <FieldReadonly :value="provider.identifier" />
    </td>
    <td class="d-block d-lg-table-cell">
      <span class="small d-lg-none fw-bold" data-no-export>{{ i18n('Name') }}</span>
      <FieldReadonly :value="provider.name" />
    </td>
    <td data-no-export class="d-block d-lg-table-cell text-end border-0 border-lg-bottom" @click.stop>
      <ActionDropdown ref="actions" :actions="actions" />
    </td>
  </tr>
</template>

<script>
import api from "@/api.js";
import FieldReadonly from "@/components/common/form/FieldReadonly.vue";
import ActionDropdown from "@/components/common/list/ActionDropdown.vue";

export default {
  components: {
    FieldReadonly,
    ActionDropdown,
  },
  props: {
    provider: Object,
  },
  data() {
    return {};
  },
  emits: [
    'edit',
    'deleted',
    'updating',
    'updated',
  ],
  methods: {
  },
  computed: {
    actions() {
      return [{
        label: this.i18n('Edit'),
        fn: () => {
          this.$emit('edit', this.provider);
        },
        if: (this.provider.acl?.update) === true,
        starred: true,
      },
      {
        label: this.i18n('Detail'),
        fn: () => {
          this.$emit('edit', this.provider);
        },
        if: (this.provider.acl?.update) !== true,
        starred: true,
      },
      {
        label: this.i18n('Delete'),
        fn: () => {
          this.$emit('updating', this.provider);
          this.$root.requestConfirmation(this.i18n('Delete? This action cannot be undone.'), () => {
            api.delete(`providers/${this.provider.id}`).then(() => {
              this.$emit('deleted', this.provider);
              api.clearCache();
            }).then(() => {
              // Force reload
              this.$emit('updated', this.provider);
            });
          });
        },
        if: (this.provider.acl?.delete) === true,
        starred: false,
      },
      ];
    },
  },
};
</script>